// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1u-2";
export var placeholderIcon = "_1u-3";
export var thumbnailCanvas = "_1u-1";
export var thumbnailWrapper = "_1u-0";